import { useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "@/lib/api";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

export default function SifremiUnuttum() {
  const [status, setStatus] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "Dersdinle";
  const institution = new URLSearchParams(window.location.search).get("hesap") === "kurum";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus(null);

    const form = e.currentTarget;
    const fd = new FormData(form);
    const email = String(fd.get("email") || "").trim();

    if (!email) return;

    setLoading(true);
    try {
      await apiRequest('/password-recovery.php',{method:'POST',body:{action:'request',email,account_type:institution?'institution':'user'}});
      setSuccess(true);
    } catch {
      setStatus("Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <main className="flex-1 flex items-center justify-center px-4 py-10 md:py-16">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="flex items-center justify-center mb-8"
            aria-label={`${name} ana sayfa`}
          >
            <img
              src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/701ba01ffa472e24f05c5cced92a417f.png"
              alt={name}
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="rounded-lg border border-background-200 bg-background-50 p-7 md:p-8">
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              {institution?'Kurum hesabı şifre sıfırlama':'Şifreni mi unuttun?'}
            </h1>
            <p className="mt-1.5 text-sm text-foreground-600">
              Kayıtlı e-posta adresini yaz, sana şifre sıfırlama bağlantısı gönderelim.
            </p>

            {success ? (
              <div className="mt-6 rounded-md bg-accent-50 border border-accent-200 p-4">
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-background-50 shrink-0">
                    <i className="ri-mail-send-line" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-accent-900">Talebin alındı</p>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                      Bu adrese ait etkin bir hesap varsa sıfırlama bağlantısı gönderilecektir. Gelen kutunu
                      (ve gerekirse spam klasörünü) kontrol edip bağlantıya tıkla. Bağlantı
                      30 dakika sonra geçersiz olur. E-posta ulaşmazsa destekle iletişime geç.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                  <label
                    htmlFor="sifremi-unuttum-email"
                    className="block text-sm font-medium text-foreground-800"
                  >
                    E-posta
                  </label>
                  <input
                    id="sifremi-unuttum-email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    placeholder="ornek@mail.com"
                    className="mt-1.5 w-full h-11 px-3.5 rounded-md border border-background-200 bg-background-100/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none transition-colors"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-11 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
                </button>
              </form>
            )}

            {status && (
              <p className="mt-4 text-sm text-foreground-600 bg-background-100 rounded-md p-3 leading-relaxed">
                {status}
              </p>
            )}

            <p className="mt-6 text-sm text-center text-foreground-600">
              Şifreni hatırladın mı?{" "}
              <Link to={institution?"/kurum/giris":"/giris"} className="text-primary-700 font-semibold hover:text-primary-800">
                Giriş Yap
              </Link>
            </p>
          </div>

          <p className="mt-6 text-center text-xs text-foreground-500">
            <Link to="/" className="hover:text-foreground-700 transition-colors">
              ← Ana sayfaya dön
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}